module.exports = __webpack_public_path__ + "static/media/rojmel.d3fabe53.svg";